import { Request } from "@/utils";
import {
    EmployeeVO,
    EmployeeSimpleVO,
    EmployeeBusinessVO,
    EmployeeEditVO,
    EmployeeEditDTO,
    DictItemVO
}from "@/types";

class BaseInfo extends Request {
    // 获取员工简单信息
    getSimpleEmployeeInfo() {
        return this.get<EmployeeSimpleVO>({
            url: '/mobile/api/getSimpleEmployeeInfo'
        });
    }
    // 获取员工基本信息
    getEmployeeDetailInfo() {
        return this.get<EmployeeVO>({
            url: '/mobile/api/getEmployeeDetailInfo'
        });
    }
    // 获取员工任职记录
    getEmployeeBusinessInfo() {
        return this.get<EmployeeBusinessVO>({
            url: '/mobile/api/getEmployeeBusinessInfo'
        });
    }
    // 获取员工编辑信息
    getEmployeeEditInfo() {
        return this.get<EmployeeEditVO>({
            url: '/mobile/api/getEmployeeEditInfo'
        });
    }
    // 搜索支行信息
    searchBankSubBranch(keyword: string) {
        return this.get<DictItemVO[]>({
            url: '/mobile/api/searchBankSubBranch',
            data: { keyword }
        });
    }
    // 获取关系列表
    getRelationList() {
        return this.get<DictItemVO[]>({
            url: '/mobile/api/getRelationList'
        });
    }
    // 获取职业列表
    getProfessionList() {
        return this.get<DictItemVO[]>({
            url: '/mobile/api/getProfessionList'
        });
    }
    // 更新员工信息
    updateEmployeeInfo(data: EmployeeEditDTO) {
        return this.post<void>({
            url: '/mobile/api/updateEmployeeInfo',
            data
        });
    }
}

export const BaseInfoApi = new BaseInfo();